import React from 'react';
import { useTranslation } from '../context/LanguageContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiExternalLink } = FiIcons;

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-white border-t border-slate-100 py-12 px-4">
      <div className="max-w-6xl mx-auto flex flex-col items-center space-y-6">
        <div className="flex flex-col items-center space-y-2">
          <p className="text-slate-400 text-[10px] font-black uppercase tracking-[0.3em]">
            {t('footer_hub')} • 2026
          </p>
          <div className="h-1 w-12 bg-indigo-100 rounded-full"></div>
        </div>
        
        <a 
          href="https://goiligan.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="group flex items-center space-x-2 bg-slate-50 hover:bg-indigo-50 px-6 py-3 rounded-2xl border border-slate-100 hover:border-indigo-100 transition-all duration-300"
        >
          <span className="text-slate-600 group-hover:text-indigo-600 text-xs font-black uppercase tracking-widest transition-colors">
            {t('visit_goiligan')}
          </span>
          <SafeIcon icon={FiExternalLink} className="text-slate-400 group-hover:text-indigo-500 transition-colors" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;